var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useCallback, useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import { mapToCssModules } from '../../utils/className';
export const SmlsInputPassword = (_a) => {
    var { idInput = '', idPreviewOn = '', idPreviewOff = '', idErrorMsg = '', className = '', textLabel = '', disabled = false, error = false, onlyNumbers = false, errorMessage = 'Error message', innerRef, ref, flipFlopClear, onChange = () => undefined, onKeyPress = () => undefined, onFocus = () => undefined, onBlur = () => undefined, onPaste = () => undefined } = _a, params = __rest(_a, ["idInput", "idPreviewOn", "idPreviewOff", "idErrorMsg", "className", "textLabel", "disabled", "error", "onlyNumbers", "errorMessage", "innerRef", "ref", "flipFlopClear", "onChange", "onKeyPress", "onFocus", "onBlur", "onPaste"]);
    const [isFocused, setIsFocused] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const [isFilled, setIsFilled] = useState(false);
    const [value, setValue] = useState('');
    const [mask, setMask] = useState('oooo');
    const enableOutline = useCallback((e) => {
        setIsFocused(true);
        onFocus(e);
    }, []);
    const disableOutline = useCallback((e) => {
        setIsFocused(false);
        onBlur(e);
    }, []);
    const handleDebouncedValue = () => {
        const hasValue = value.length > 0;
        setIsTyping(false);
        setIsFilled(hasValue);
    };
    useEffect(() => {
        const debounceTimeout = setTimeout(handleDebouncedValue, 500);
        return () => {
            clearTimeout(debounceTimeout);
        };
    }, [value]);
    useEffect(() => {
        setMask('oooo');
        setValue('');
    }, [flipFlopClear]);
    const handleOnChange = useCallback((event) => {
        let text = event.target.value.slice(0, 4);
        let updatedMask = '';
        const hasOnlyNumbers = /^\d+$/g.test(event.target.value);
        if (onlyNumbers && !hasOnlyNumbers) {
            text = text.replace(/\D+/g, '');
        }
        for (let i = 0; i < 4; i += 1) {
            updatedMask += i < text.length ? ' ' : 'o';
        }
        setMask(updatedMask);
        setIsTyping(true);
        setValue(text);
        onChange(Object.assign(Object.assign({}, event), { target: {
                value: text,
            } }));
    }, [onlyNumbers]);
    return (React.createElement("div", { className: mapToCssModules([
            'input-group icon password',
            isVisible ? 'visible' : '',
            disabled ? 'disabled' : '',
            isTyping ? 'typing' : '',
            isFilled ? 'filled' : '',
            isFocused ? 'input-outline' : '',
            error ? 'error' : '',
        ]) },
        textLabel && React.createElement("label", { htmlFor: idInput }, textLabel),
        React.createElement("div", null,
            React.createElement(Input, Object.assign({ id: idInput, className: className, disabled: disabled, value: value, type: isVisible ? 'text' : 'password', ref: ref, onChange: handleOnChange, onFocus: enableOutline, onBlur: disableOutline, onPaste: onPaste, onKeyPress: onKeyPress, innerRef: innerRef }, params)),
            React.createElement("i", { id: idPreviewOff, onClick: () => setIsVisible((prevState) => !prevState), className: "material-icons notranslate" }, "\uE8F5"),
            React.createElement("i", { id: idPreviewOn, onClick: () => setIsVisible((prevState) => !prevState), className: "material-icons notranslate" }, "\uE8F4"),
            React.createElement("span", { id: "mask", "data-mask": mask })),
        React.createElement("div", { className: "input-error" }, error && (React.createElement(React.Fragment, null,
            React.createElement("i", { className: "material-icons notranslate" }, "\uE001"),
            React.createElement("label", { id: idErrorMsg, htmlFor: "input-text" }, errorMessage))))));
};
//# sourceMappingURL=index.js.map